/*
 * Portions of this code are from Novel (https://github.com/steven-tey/novel)
 * Copyright (c) 2023 Steven Tey
 * Licensed under the Apache License, Version 2.0
 */

import { Slot } from '@radix-ui/react-slot'
import type { Editor } from '@tiptap/react'
import { useCurrentEditor } from '@tiptap/react'
import type { ComponentPropsWithoutRef, ReactNode } from 'react'
import { forwardRef } from 'react'

interface EditorBubbleItemProps {
  readonly children: ReactNode
  readonly asChild?: boolean
  readonly onSelect?: (editor: Editor) => void
}

export const EditorBubbleItem = forwardRef<
  HTMLDivElement,
  EditorBubbleItemProps & Omit<ComponentPropsWithoutRef<'div'>, 'onSelect'>
>(({ children, asChild, onSelect, ...rest }, ref) => {
  const { editor } = useCurrentEditor()

  if (!editor) return null

  if (asChild) {
    return (
      <Slot ref={ref} onClick={() => onSelect?.(editor)}>
        {children}
      </Slot>
    )
  }

  return (
    <div ref={ref} {...rest} onClick={() => onSelect?.(editor)}>
      {children}
    </div>
  )
})

EditorBubbleItem.displayName = 'EditorBubbleItem'

export default EditorBubbleItem
